module.exports = __webpack_public_path__ + "img/bin-c-5.a4032f52.svg";